var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _g, _path10, _path11, _rect, _path12, _path13, _path14, _path15, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCartIllustartion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 299,
    height: 342,
    viewBox: "0 0 299 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.666 257.252C122.666 251.145 127.616 246.195 133.722 246.195H197.872C206.637 246.195 215.015 248.789 221.466 253.531C227.914 258.271 233.033 265.725 233.033 274.977C233.033 284.227 227.916 291.682 221.47 296.425C215.019 301.17 206.64 303.769 197.872 303.769H45.446C39.3397 303.769 34.3896 298.819 34.3896 292.712C34.3896 286.606 39.3397 281.656 45.446 281.656H197.872C202.419 281.656 206.092 280.286 208.365 278.613C210.643 276.938 210.921 275.525 210.921 274.977C210.921 274.43 210.645 273.021 208.369 271.348C206.097 269.677 202.422 268.308 197.872 268.308L133.076 266.137C126.97 266.137 122.666 263.358 122.666 257.252Z",
    fill: "url(#paint0_linear_26889_73069)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M223.292 125.212C224.747 119.774 229.674 115.992 235.303 115.992H285.593C292.459 115.992 298.026 121.559 298.026 128.426C298.026 135.293 292.459 140.859 285.593 140.859H244.847L230.34 195.081C228.566 201.715 221.749 205.654 215.116 203.879C208.482 202.104 204.543 195.288 206.318 188.654L223.292 125.212Z",
    fill: "url(#paint1_linear_26889_73069)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M212.547 78.6807H61.6999L49.7998 104.691H200.636L212.547 78.6807Z",
    fill: "url(#paint2_linear_26889_73069)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M136.551 74.751H37.8877L49.7987 104.692H148.451L136.551 74.751Z",
    fill: "url(#paint3_linear_26889_73069)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M214.562 74.751H160.364L148.453 104.692H202.651L214.562 74.751Z",
    fill: "url(#paint4_linear_26889_73069)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M202.661 104.691H103.998V203.354H202.661V104.691Z",
    fill: "url(#paint5_linear_26889_73069)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M148.463 104.691H49.7998V203.354H148.463V104.691Z",
    fill: "url(#paint6_linear_26889_73069)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2669 342.001C97.1431 342.001 109.203 329.941 109.203 315.065C109.203 300.188 97.1431 288.129 82.2669 288.129C67.3906 288.129 55.3311 300.188 55.3311 315.065C55.3311 329.941 67.3906 342.001 82.2669 342.001Z",
    fill: "url(#paint7_linear_26889_73069)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M215.944 149.335H30.3217C16.4074 149.335 6.12954 161.137 9.27604 173.484L24.3989 246.104C26.6744 255.02 35.3953 261.346 45.4445 261.346L209.114 271.937L237.033 173.516C243.911 153.368 229.891 149.335 215.944 149.335Z",
    fill: "url(#paint8_linear_26889_73069)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5236 328.643C88.9973 328.643 95.0559 322.584 95.0559 315.11C95.0559 307.637 88.9973 301.578 81.5236 301.578C74.0498 301.578 67.9912 307.637 67.9912 315.11C67.9912 322.584 74.0498 328.643 81.5236 328.643Z",
    fill: "url(#paint9_linear_26889_73069)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_26889_73069",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 149,
    width: 230,
    height: 123
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M215.944 149.335H30.3217C16.4074 149.335 6.12954 161.137 9.27604 173.484L24.3989 246.104C26.6744 255.02 35.3953 261.346 45.4445 261.346L209.114 271.937L237.033 173.516C240.179 161.137 229.891 149.335 215.944 149.335Z",
    fill: "url(#paint10_linear_26889_73069)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_26889_73069)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.4653,
    height: 71.794,
    rx: 7.73265,
    transform: "matrix(0.999966 0.00825468 -0.0123002 0.999924 137.426 205.105)",
    fill: "url(#paint11_linear_26889_73069)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.4653,
    height: 272.31,
    rx: 6.44398,
    transform: "matrix(0.00661527 0.999978 -0.999997 0.00256955 277.31 153.657)",
    fill: "url(#paint12_linear_26889_73069)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.4653,
    height: 71.794,
    rx: 7.73265,
    transform: "matrix(0.999966 0.00825468 -0.0123002 0.999924 181.134 205.292)",
    fill: "url(#paint13_linear_26889_73069)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.4653,
    height: 71.794,
    rx: 7.73265,
    transform: "matrix(0.999966 0.00825468 -0.0123002 0.999924 93.7188 204.92)",
    fill: "url(#paint14_linear_26889_73069)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.4653,
    height: 71.794,
    rx: 7.73265,
    transform: "matrix(0.999966 0.00825468 -0.0123002 0.999924 49.542 204.92)",
    fill: "url(#paint15_linear_26889_73069)"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179.283 3.97595C177.4 0.675053 173.905 -0.87769 171.476 0.507787C169.048 1.89326 168.605 5.69231 170.488 8.9932C170.542 9.0864 170.596 9.1782 170.652 9.26858C169.417 9.52206 168.257 10.7291 167.802 12.3918C167.217 14.532 168.021 16.6168 169.599 17.0483C171.177 17.4797 172.93 16.0945 173.515 13.9543C173.676 13.3683 173.732 12.7864 173.696 12.2415C175.251 13.0926 176.939 13.2349 178.295 12.4614C179.489 11.7804 180.203 10.5163 180.397 9.0148C180.722 9.18373 181.076 9.32361 181.455 9.42703C183.595 10.0124 185.679 9.20801 186.111 7.63041C186.542 6.05281 185.157 4.29938 183.017 3.71402C181.639 3.33715 180.284 3.53635 179.379 4.14709C179.348 4.0899 179.316 4.03285 179.283 3.97595Z",
    fill: "url(#paint16_linear_26889_73069)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.829 16.9071C66.724 18.0333 65.3328 18.6234 63.9282 18.4058C62.3011 18.1538 61.019 16.8743 60.3584 15.098C60.0591 15.5026 59.6817 15.8814 59.2342 16.2089C57.4437 17.5192 55.2091 17.5114 54.2432 16.1915C53.2774 14.8716 53.9459 12.7394 55.7365 11.4291C57.158 10.3889 58.8593 10.1794 59.9835 10.7976C60.576 7.05959 63.2796 4.37943 66.0345 4.8061C68.751 5.22684 70.5061 8.51191 70.0118 12.1913C71.0771 12.3051 72.2224 12.9867 73.0443 14.1099C74.3547 15.9005 74.3469 18.135 73.027 19.1009C71.7071 20.0668 69.5749 19.3982 68.2646 17.6076C68.0981 17.3801 67.9529 17.1454 67.829 16.9071Z",
    fill: "url(#paint17_linear_26889_73069)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.973633,
    y: 146.923,
    width: 243.582,
    height: 16.7543,
    rx: 8.37717,
    fill: "url(#paint18_linear_26889_73069)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9909 20.7568C60.7725 29.6305 67.9583 48.2758 79.0502 49.7547C99.5738 52.4913 95.8046 28.4896 83.561 33.0004C68.9895 38.3688 83.5715 61.3328 103.537 66.5091",
    stroke: "#8BA0BF",
    strokeWidth: 1.2888,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "5.16 5.16"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M179.646 18.5166C191.844 42.2568 159.526 67.6022 150.579 72.2979",
    stroke: "#8BA0BF",
    strokeWidth: 1.2888,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "5.16 5.16"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M167.963 342.001C182.839 342.001 194.899 329.941 194.899 315.065C194.899 300.188 182.839 288.129 167.963 288.129C153.087 288.129 141.027 300.188 141.027 315.065C141.027 329.941 153.087 342.001 167.963 342.001Z",
    fill: "url(#paint19_linear_26889_73069)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M167.872 328.643C175.346 328.643 181.405 322.584 181.405 315.11C181.405 307.637 175.346 301.578 167.872 301.578C160.398 301.578 154.34 307.637 154.34 315.11C154.34 322.584 160.398 328.643 167.872 328.643Z",
    fill: "url(#paint20_linear_26889_73069)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_26889_73069",
    x1: 34.4834,
    y1: 196.542,
    x2: 94.5998,
    y2: 256.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C93AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2E0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_26889_73069",
    x1: 343.896,
    y1: 123.157,
    x2: 209.216,
    y2: 125.668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9EB9E0"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ACC4E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_26889_73069",
    x1: 49.6155,
    y1: 84.6835,
    x2: 213.169,
    y2: 91.3277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDEDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BA0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_26889_73069",
    x1: 93.1693,
    y1: 74.751,
    x2: 93.1693,
    y2: 104.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDEDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BA0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_26889_73069",
    x1: 181.508,
    y1: 74.751,
    x2: 181.508,
    y2: 104.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDEDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BA0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_26889_73069",
    x1: 101.036,
    y1: 178.677,
    x2: 243.58,
    y2: 180.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.392237,
    stopColor: "#DDEDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BA0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_26889_73069",
    x1: 77.0125,
    y1: 159.167,
    x2: 130.556,
    y2: 173.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDEDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BA0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_26889_73069",
    x1: 82.2669,
    y1: 288.129,
    x2: 82.2669,
    y2: 342.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5E0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDDCFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_26889_73069",
    x1: 8.44681,
    y1: 178.032,
    x2: 238.824,
    y2: 180.786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDEDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93B4D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_26889_73069",
    x1: 67.1786,
    y1: 321.873,
    x2: 106.281,
    y2: 322.492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6F0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4C7FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_26889_73069",
    x1: 8.44681,
    y1: 178.032,
    x2: 238.824,
    y2: 180.786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCC7D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5B7BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_26889_73069",
    x1: -0.464356,
    y1: 53.8367,
    x2: 21.8846,
    y2: 53.9129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6E2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8192AA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_26889_73069",
    x1: 7.73265,
    y1: 0,
    x2: 7.73265,
    y2: 272.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9EC3EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9EBDDF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_26889_73069",
    x1: -0.464356,
    y1: 53.8367,
    x2: 21.8846,
    y2: 53.9129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6E2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8192AA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_26889_73069",
    x1: -0.464356,
    y1: 53.8367,
    x2: 21.8846,
    y2: 53.9129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6E2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8192AA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_26889_73069",
    x1: -0.464356,
    y1: 53.8367,
    x2: 21.8846,
    y2: 53.9129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6E2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8192AA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_26889_73069",
    x1: 167.59,
    y1: 3.95342,
    x2: 186.291,
    y2: 4.08513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BA0BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#468AEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8B7CD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_26889_73069",
    x1: 62.1679,
    y1: 5.29109,
    x2: 74.1536,
    y2: 18.1944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BA0BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#468AEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8B7CD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_26889_73069",
    x1: 248.5,
    y1: 125,
    x2: -4.23049,
    y2: 110.656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FC1E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_26889_73069",
    x1: 167.963,
    y1: 288.129,
    x2: 167.963,
    y2: 342.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5E0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDDCFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_26889_73069",
    x1: 153.527,
    y1: 321.873,
    x2: 192.629,
    y2: 322.492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6F0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4C7FC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartIllustartion);
export default __webpack_public_path__ + "static/media/Cart_Illustartion.ac88ffee8e651c196ea8b394df4a9ac5.svg";
export { ForwardRef as ReactComponent };